import React, { useState } from "react";
import {
  Box, Button, Grid, TextField, Typography, CircularProgress
} from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import axios from "axios";

const SignupForm = ({ onBack, onLogin }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSignup = async (e) => {
    e.preventDefault();
    setError(""); setSuccess(""); setLoading(true);
    try {
      const res = await axios.post("/api/auth/signup", { email, password, name });
      if (res.data.success) {
        setSuccess("Signup successful! You can now log in.");
        setEmail(""); setPassword(""); setName("");
        setTimeout(() => onLogin(), 1000);
      } else {
        setError(res.data.message || "Signup failed.");
      }
    } catch (err) {
      setError(err.response?.data?.message || "An error occurred.");
    } finally { setLoading(false); }
  };

  return (
    <Box>
      <Typography variant="h5" align="center" style={{ marginBottom: 12 }}>
        Create an Account
      </Typography>

      {error && <Alert severity="error" style={{ marginBottom: 12 }}>{error}</Alert>}
      {success && <Alert severity="success" style={{ marginBottom: 12 }}>{success}</Alert>}

      <form onSubmit={handleSignup}>
        <Grid container direction="column" spacing={2}>
          <Grid item>
            <TextField label="Name" fullWidth required value={name}
              onChange={(e) => setName(e.target.value)} />
          </Grid>
          <Grid item>
            <TextField label="Email" fullWidth type="email" required value={email}
              onChange={(e) => setEmail(e.target.value)} />
          </Grid>
          <Grid item>
            <TextField label="Password" fullWidth type="password" required value={password}
              onChange={(e) => setPassword(e.target.value)} />
          </Grid>
          <Grid item>
            <Button type="submit" variant="contained" fullWidth disabled={loading}>
              {loading ? <CircularProgress size={24} /> : "Sign Up"}
            </Button>
          </Grid>
          <Grid item>
            <Button fullWidth variant="text" onClick={onLogin}>
              Already have an account? Log in
            </Button>
          </Grid>
          <Grid item>
            <Button fullWidth variant="text" onClick={onBack}>← Back</Button>
          </Grid>
        </Grid>
      </form>
    </Box>
  );
};

export default SignupForm;
